<template>
    <span>
        <el-dialog
          append-to-body
          :close-on-click-modal="true"
          :title='videoFile.S_ORIGINAL_NAME'
          :visible.sync="showVideoStatus"
          width="35%"
          @close="$emit('closeVideo')"
        >
          <div>
            <video width="100%" height="500"  controls autoplay>
              <source :src="videoFile.src" type="video/mp4">
            </video>
          </div>
        </el-dialog>
    </span>
</template>

<script>

export default {
    name: 'LayuiVideo',
    props: {
      showVideoStatus: {
        type: Boolean,
        default: () => {
          return false;
        },
      },
      videoFile: {
        type: Object,
        default: () => {
          return {};
        }
      },
    },
    data() {
      return {
        dialogVisible: false,
      }
    },
    methods: {
    },
    mounted(){
    },


  }

</script>



// WEBPACK FOOTER //
// src/components/common/LayuiVideo.vue